export default {
  processSteps: 'Kroki procesu',
};
